<template>
  <div class="animate__animated animate__fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4>Con dấu tổ chức</h4>
          </div>
          <div class="text-right customs">
            <el-button
              @click="save()"
              class="pl-2 btn-default"
              type="primary"
              round
              :disabled="!dataForm.id && (!dataForm.image_ids || dataForm.image_ids.length === 0)"
            >
              Lưu
              <i class="isax-save-add"></i>
            </el-button>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="upload__block text-center">
            <el-upload
              :auto-upload="false"
              drag
              action
              multiple
              :accept="fileUploadOption.accept"
              :on-change="uploadOrganizationSeal"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Thả ảnh vào đây hoặc <em>click để upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                <p><i>Chỉ tải ảnh có định dạng PNG, có kích thước không quá 220 x 220px</i></p>
              </div>
            </el-upload>
          </div>
          <div class="list-organization-seal mt-4">
            <b-row>
              <b-col
                class="mb-4"
                v-for="(item, index) in fileUploadOption.listOrganizationSeals"
                :key="index"
                md="3"
              >

                <div
                  class="text-center seal"
                  @mouseover="mouseOver(true,index)"
                  @mouseleave="mouseOver(false,index)"
                >
                  <el-image
                    :src="item.url"
                    @click="showDetailImage(item.url)"
                    fit="cover"
                  ></el-image>
                  <el-button class="btn-back btn-delete-image" v-if="item.showButtonDelete" @click="deleteOrganizationSeal(item.id)" title="Xóa">
                    <i class="el-icon-delete"></i>
                  </el-button>
              </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <el-image-viewer
      class="dialog__image-viewer"
      v-if="visibleDialogImage"
      :on-close="closeViewer"
      :url-list="[urlImage]"
    />
  </div>
</template>
<script>
  import ExtensionService from '@/service/ExtensionService';
  import MethodService from '@/service/MethodService';
  import OrganizationSealModel from './OrganizationSealModel';
  import CompanySignApi from '@/moduleApi/CompanySignApi';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: {
    ElImageViewer
  },
  data() {
    return {
      dataForm: MethodService.copyObject(OrganizationSealModel.dataForm),
      visibleDialogImage: false,
      urlImage: '',
      fileUploadOption: {
        accept: ".png",
        listOrganizationSeals: [],
      },
      companyInfo: MethodService.getCompanyInfo()
    };
  },
  methods: {
    mouseOver(event, index){
      this.fileUploadOption.listOrganizationSeals[index].showButtonDelete = event;
    },
    showDetailImage(url){
      this.urlImage = url;
      setTimeout(() => {
        this.visibleDialogImage = true;
      }, 100);
    },
    closeViewer() {
      this.visibleDialogImage = false;
    },
    deleteOrganizationSeal(id) {
      this.dataForm.image_ids = this.dataForm.image_ids.filter(item => item !== id);
      this.fileUploadOption.listOrganizationSeals = this.fileUploadOption.listOrganizationSeals.filter(item => item.id !== id);
    },
    async getListOrganizationSeals() {
      const res = await CompanySignApi.list({
        company_id: this.companyInfo.id,
        limit: 10000,
      });
      this.fileUploadOption.listOrganizationSeals = [];
      if (res && res.result && res.result.length > 0) {
        this.dataForm = MethodService.copyObject(res.result[0]);
        (res.result[0].image_ids || []).forEach(item => {
          this.fileUploadOption.listOrganizationSeals.push({
            showButtonDelete: false,
            id: item,
            url: ExtensionService.urlImg + item
          })
        })
      }
    },
    save() {
      if (this.dataForm.id) {
        this.updateOrganizationSeal();
      } else {
        this.createOrganizationSeal();
      }
    },
    async createOrganizationSeal() {
      let data = this.dataForm;
      data.company_id = this.companyInfo.id;
      try {
        await CompanySignApi.create(data);
        toastr.success("Lưu thành công");
        this.getListOrganizationSeals();
      } catch (error) {
        toastr.error("Lưu thất bại");
      }
    },
    async updateOrganizationSeal() {
      let data = this.dataForm;
      try {
        await CompanySignApi.update(data);
        toastr.success("Lưu thành công");
        this.getListOrganizationSeals();
      } catch (error) {
        toastr.error("Lưu thất bại");
      }
    },
    checkTypeImageBeforeUpload(file) {
      if (file.raw && file.raw.type == "image/png") {
        return true;
      } else {
        toastr.warning("Chỉ được tải lên file ảnh có định dạng PNG");
        return false;
      }
    },
    async uploadOrganizationSeal(file, fileList) {
      if (!this.checkTypeImageBeforeUpload(file)) return
      const res = await ExtensionService.upload(file, "ConDauToChuc");
      if (res && res.result) {
        let resultCheck = await MethodService.checkWidthHeightImage(res.result, 220, 220);
        if (!resultCheck.status) {
          toastr.warning(resultCheck.message ? resultCheck.message : "Kích thước ảnh không hợp lệ");
          return;
        }
        this.dataForm.image_ids.push(res.result);
        this.fileUploadOption.listOrganizationSeals.push({
          showButtonDelete: false,
          id: res.result,
          url: ExtensionService.urlImg + res.result
        })
      }
    }
  },
  created() {
    this.getListOrganizationSeals();
  },
}
</script>
<style lang="scss" scoped>
  [class^=isax-] {
    margin-left: 10px;
    &::before {
      font-size: 17px;
    }
  }
  ::v-deep .el-upload-list {
    display: none;
  }
  ::v-deep .main-body {
    background-color: #fff;
    border-radius: 10px;
    min-height: calc(100vh - 155px);
    .seal {
      .el-image {
        max-width: 220px;
      }
      .btn-delete-image {
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 9;
        transform: translate(-50%, -50%);
      }
    }
    .list-organization-seal {
      max-height: calc(100vh - 400px);
      overflow-y: auto;
    }
  }
</style>
